// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"384":"afb1ada2","783":"db7d0e04","788":"c105f8fb","887":"2f52b118"}[chunkId] + ".chunk.js";
};